import React, { useState, useEffect } from 'react';
import './brand.css';

const Brand = () => {
  const [google, setGoogle] = useState(null);
  const [slack, setSlack] = useState(null);
  const [atlassian, setAtlassian] = useState(null);
  const [dropbox, setDropbox] = useState(null);
  const [shopify, setShopify] = useState(null);

  useEffect(() => {
    Promise.all([
      import('../../assets/google.webp'),
      import('../../assets/slack.webp'),
      import('../../assets/atlassian.webp'),
      import('../../assets/dropbox.webp'),
      import('../../assets/shopify.webp'),
    ]).then(([googleImg, slackImg, atlassianImg, dropboxImg, shopifyImg]) => {
      setGoogle(googleImg.default);
      setSlack(slackImg.default);
      setAtlassian(atlassianImg.default);
      setDropbox(dropboxImg.default);
      setShopify(shopifyImg.default);
    });
  }, []);

  return (
    <section className="gpt3__brand section__padding">
      {google && (
        <div>
          <img src={google} alt="Google Logo" aria-label="Google" />
        </div>
      )}
      {slack && (
        <div>
          <img src={slack} alt="Slack Logo" aria-label="Slack" />
        </div>
      )}
      {atlassian && (
        <div>
          <img src={atlassian} alt="Atlassian Logo" aria-label="Atlassian" />
        </div>
      )}
      {dropbox && (
        <div>
          <img src={dropbox} alt="Dropbox Logo" aria-label="Dropbox" />
        </div>
      )}
      {shopify && (
        <div>
          <img src={shopify} alt="Shopify Logo" aria-label="Shopify" />
        </div>
      )}
    </section>
  );
};

export default Brand;
